import { useGetAppCtas } from "../../../../service/api";
import { SpinnerBlock } from "../../../common/Spinner";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { routes } from "../../../../appRoutingHelpers";
import { Table } from "../../../../components/table-components/Table";
import { CtasListHeader } from "./CtasListHeader";
import { CtasListRow } from "./CtasListRow";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { Placeholder } from "../../../../components/Placeholder";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { useHandleFetchError } from "../../../../error-handler";

export const CtasList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: ctas, isLoading, error: getCtasError } = useGetAppCtas(
    organizationKeyName
  );

  useHandleFetchError(getCtasError);

  if (!ctas || isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <CardContainer>
      <PageHeader
        title="Call to action list"
        subtitle="Create, manage and edit app call to actions. The call to action will automatically appear on your app homepages."
      >
        <ButtonInternalLink to={routes.ctasNew(organizationKeyName)}>
          Add new
        </ButtonInternalLink>
      </PageHeader>
      {ctas.length === 0 ? (
        <Placeholder>
          No call to actions created yet! Create your first and it will
          automatically display on the frontpage of your app.
        </Placeholder>
      ) : (
        <Table>
          <CtasListHeader />
          <tbody>
            {ctas.map((cta, index) => (
              <CtasListRow key={index} cta={cta} />
            ))}
          </tbody>
        </Table>
      )}
    </CardContainer>
  );
};
